var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.hideWrapper ? '' : 'c-preview-wrapper'},[_c('img',{staticClass:"img-preview img-thumbnail",attrs:{"src":_setup.source,"alt":_vm.alt},on:{"error":_setup.onErrorHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }